module.exports = "/images/logo_04.png?b8ac0d2f80a5d4ece2650e731ebf342c";